import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);
export const SetupNewPassword = createAsyncThunk(
  "auth/SetupNewPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/setup-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);
export const ResetNewPassword = createAsyncThunk(
  "auth/ResetNewPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Logout failed");
      }

      return json; // success message or status
    } catch (err) {
      return rejectWithValue(err.message || "Unexpected error during logout");
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/forgot-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const updateVendorUser = createAsyncThunk(
  "auth/updateVendorUser",
  async (data, { getState, rejectWithValue }) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body,
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Password update failed");
      }

      return json;
    } catch (error) {
      console.error("Update vendor user error:", error);
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const verifyTwoFactorCode = createAsyncThunk(
  "auth/verifyTwoFactorCode",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(
        `${API_BASE}/api/auth/app/verify-two-factor-code`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "vendor",
          },
          body: body,
        }
      );

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const ResetPasswordToken = createAsyncThunk(
  "auth/ResetPasswordToken",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const checkAuthStatus = createAsyncThunk(
  "auth/checkStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/me`, {
        method: "GET",
        credentials: "include", // include cookies
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json.message || "Not authenticated");
      }

      return json; // e.g., user data
    } catch (err) {
      return rejectWithValue(err.message || "Auth check failed");
    }
  }
);
